import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChartResults, SeriesChart, Statistics, StatisticsChart } from '../../core/model/cliente';
import { ComboCliente } from '../../core/model/combos';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        opacity: 1,
        height: '*'
      })),
      state('out', style({
        opacity: 0,
        height: '0'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class StatisticsComponent implements OnInit {

  @Input() statistics: Statistics;
  @Input() isDocoutUser: boolean;

  isChartTwoDimenssions = false;

  results: ChartResults[] | SeriesChart[];
  statisticsPanelSelected: StatisticsChart[] = null;
  colorScheme = {
    domain: ['#0073b7', '#00a65a', '#bc4031', '#f39c12', '#00a3cb', '#4512AE', '#00A779', '#BC008D', '#06799F', '#000000']
  };

  hasShowStatistics = false;
  arrowLeft: number;


  advancedSearchState = 'out';


  statisticClients: ComboCliente[] = [];

  keyLegend: string;

  constructor(private translateService: TranslateService,
    private router: Router) { }

  ngOnInit() {
  }

  toggleStatisticsPanel(percentLeft: number, panelStatisticToShow: StatisticsChart[], keyLegend: string) {
    if (this.arrowLeft != percentLeft) {
      this.hasShowStatistics = true;
      this.advancedSearchState = 'in';
    } else {
      this.hasShowStatistics = !this.hasShowStatistics;
      this.advancedSearchState = this.hasShowStatistics ? 'in' : 'out';
    }
    if (this.hasShowStatistics) {
      this.keyLegend = keyLegend;
      this.showStatistics(panelStatisticToShow);
    } else {
      this.statisticsPanelSelected = [];
      this.keyLegend = undefined;
    }
    this.arrowLeft = percentLeft;
  }

  private showStatistics(panelStatisticToShow: StatisticsChart[]) {
    if (panelStatisticToShow.length == 1) {
      this.results = panelStatisticToShow[0].results;
    } else {
      const panelClients = panelStatisticToShow.find(panelStatistic => panelStatistic.client == -1);
      panelClients.clientName = this.translateService.instant(panelClients.clientName);
      this.results = panelStatisticToShow.find(panelStatistic => panelStatistic.client == -1).results;
    }
    this.isChartTwoDimenssions = panelStatisticToShow[0].isTwoDimenssions;
    this.statisticClients = panelStatisticToShow.map(panelStatistic => ({ Id: panelStatistic.client, NOMBRE: panelStatistic.clientName }));
    this.statisticsPanelSelected = panelStatisticToShow;
  }

  onStadisticsClientChange(value) {
    const resultSelected = this.statisticsPanelSelected.find(x => x.client == value);
    this.results = resultSelected.results;
    this.isChartTwoDimenssions = resultSelected.isTwoDimenssions;
  }

  showSolicitudes(idFiltroEstadisticas: number) {
    this.router.navigate(['docout', {
      outlets: {
        contenido: ['consulta', {
          filterId: 14,
          value: idFiltroEstadisticas
        }]
      }
    }]);
  }

}
